import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import { reviewAPI } from '../services/api';

const WriteReviewPage = () => {
  const { bookId } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [rating, setRating] = useState(5);
  const [reviewText, setReviewText] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (!currentUser) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">You must be logged in to write a review.</h2>
        <Button variant="primary" onClick={() => navigate('/login')}>Login</Button>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await reviewAPI.addReview(bookId, { rating, reviewText });
      navigate(`/books/${bookId}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to submit review');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background-light py-12">
      <div className="container mx-auto px-4 flex justify-center">
        <Card className="p-8 max-w-lg w-full">
          <h2 className="text-2xl font-bold mb-6 text-center">Write a Review</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4 flex flex-col items-center">
              <label className="mb-2 font-semibold">Your Rating</label>
              <div className="flex space-x-1">
                {[1,2,3,4,5].map((star) => (
                  <button
                    type="button"
                    key={star}
                    className={
                      star <= rating
                        ? 'text-yellow-500 text-2xl'
                        : 'text-gray-300 text-2xl'
                    }
                    onClick={() => setRating(star)}
                  >
                    ★
                  </button>
                ))}
              </div>
            </div>
            <div className="mb-4">
              <label className="block mb-2 font-semibold">Your Review</label>
              <Input
                type="expandable-text"
                value={reviewText}
                onChange={e => setReviewText(e.target.value)}
                placeholder="Share your thoughts about this book..."
                required
                className="w-full"
                rows={5}
              />
            </div>
            {error && <div className="text-red-500 mb-4 text-center">{error}</div>}
            <div className="flex justify-center">
              <Button
                variant="primary"
                type="submit"
                disabled={submitting}
              >
                {submitting ? 'Submitting...' : 'Submit Review'}
              </Button>
              <Button
                variant="secondary"
                className="ml-4"
                onClick={() => navigate(`/books/${bookId}`)}
                type="button"
              >
                Cancel
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default WriteReviewPage; 